import { Pagination, PaginationItem, useMediaQuery } from '@mui/material'
import { useRouter } from 'next/compat/router'
import Link from 'next/link'
import { useState } from 'react'
import { usePagination } from 'react-instantsearch'
import { match, P } from 'ts-pattern'
import { themeUtils } from 'styles/theme'

const PaginationComponent = () => {
  const router = useRouter()
  const paginationResult = usePagination({ padding: 1 })
  const { nbPages, refine } = paginationResult
  const [page, setPage] = useState(Number(router?.query?.page) || 1)

  const isMobile = useMediaQuery(themeUtils.maxWidth.md)

  if (!router?.isReady) return null

  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    event.preventDefault()
    setPage(value)
    window.scrollTo({ top: 0, behavior: 'smooth' })
    refine(value - 1)
  }

  return (
    <Pagination
      count={nbPages}
      color="primary"
      size={isMobile ? 'medium' : 'large'}
      page={page}
      shape="rounded"
      sx={{ alignSelf: 'center', paddingTop: 3, paddingBottom: 8 }}
      onChange={handlePaginationChange}
      siblingCount={isMobile ? 1 : 2}
      renderItem={(item) =>
        match(item)
          .with(
            P.union(
              { type: 'next', page: P.number.gt(nbPages) },
              { type: 'previous', page: 0 }
            ),
            () => <PaginationItem {...item} />
          )
          .otherwise(() => (
            <PaginationItem
              component={Link}
              href={{
                pathname: router.pathname,
                query: { ...router.query, page: item.page }
              }}
              {...item}
            />
          ))
      }
    />
  )
}

export default PaginationComponent
